import { Suspense } from 'react';

import { useGetContext } from '@api/lendingAPI/lapiHooks';
import { Text } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AccountCard } from './accountCard/AccountCard';
import { DashboardLoading } from './DashboardLoading';
import { useGetDashboardRedirect } from './useGetDashboardRedirect';
import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import { useTrackPageView } from '../../tracking/pageView';
import FallbackErrorModal from '../modals/fallbackErrorModal/FallbackErrorModal';
import InternationalisedName from '../multiLoanDashboard/dashboardComponents/InternationalisedName';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    redirectToLocation: (pathname: string) =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: pathname
            }
        })
});

export const Dashboard = () => {
    useTrackPageView({ name: 'Flexi-12 Dashboard' });

    return (
        <ErrorBoundary fallback={() => <FallbackErrorModal />}>
            <Suspense fallback={<DashboardLoading />}>
                <div className="h-full w-full bg-structure-100 px-[10%] py-3xl max-sm:px-xl">
                    <Text className="text-3xl font-bold">
                        <FormattedMessage
                            id="_.dashboard_home.greeting"
                            defaultMessage="Welcome {name}"
                            values={{ name: <InternationalisedName /> }}
                        />
                    </Text>
                    <div
                        className="my-3xl grid grid-cols-7"
                        data-testid="active-loans-section"
                    >
                        <Text className="col-span-full mb-l text-l font-bold">
                            <FormattedMessage
                                id="_.dashboard_home.business_loans.heading"
                                defaultMessage="Active business loans"
                            />
                        </Text>
                        <AccountList />
                    </div>
                </div>
            </Suspense>
        </ErrorBoundary>
    );
};

const AccountList = connect(
    null,
    mapDispatchToProps
)(({ redirectToLocation }: ReturnType<typeof mapDispatchToProps>) => {
    const { data: context } = useGetContext();

    const isAccessUser = context?.logged_in_user_type === 'access_user';

    if (isAccessUser) {
        redirectToLocation('/napg-view/');
        return null;
    }

    const { redirectTo, activeFundedAccounts } = useGetDashboardRedirect();

    if (redirectTo && redirectTo.pathname) {
        redirectToLocation(redirectTo.pathname);
        return null;
    }
    return (
        <>
            {activeFundedAccounts &&
                activeFundedAccounts.length > 0 &&
                activeFundedAccounts.map((account) => (
                    <AccountCard account={account} key={account.account_id} />
                ))}
        </>
    );
});
